import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Pill, UserCheck, Store, ShoppingBag } from 'lucide-react';

const SECTIONS = [
  {
    icon: UserCheck,
    label: 'Recomendados por tu Entrenador',
    description: 'Suplementos seleccionados especialmente para ti',
    path: '/client/supplements/recommended',
    color: '#F97316',
    gradient: 'from-orange-500 to-amber-500',
  },
  {
    icon: Store,
    label: 'Tienda',
    description: 'Explora el catalogo completo de productos',
    path: '/client/supplements/store',
    color: '#6366F1',
    gradient: 'from-indigo-500 to-violet-500',
  },
  {
    icon: ShoppingBag,
    label: 'Tus Pedidos',
    description: 'Historial de todas tus ordenes realizadas',
    path: '/client/supplements/orders',
    color: '#8B5CF6',
    gradient: 'from-violet-500 to-purple-500',
  },
];

const ClientSupplementsPage = () => {
  const navigate = useNavigate();

  return (
    <div className="max-w-2xl mx-auto space-y-5 animate-fade-in pb-4" data-testid="client-supplements-page">
      <div className="pt-1">
        <div className="flex items-center gap-2.5">
          <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-orange-500 to-amber-500 flex items-center justify-center shadow-lg shadow-orange-500/20">
            <Pill size={18} className="text-white" />
          </div>
          <div>
            <h1 className="text-3xl font-bold text-gray-900" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
              Suplementos
            </h1>
          </div>
        </div>
        <p className="text-sm text-gray-400 mt-2 font-medium">Nutricion y bienestar a tu alcance</p>
      </div>

      <div className="space-y-3">
        {SECTIONS.map((section, idx) => {
          const IconComp = section.icon;
          return (
            <button
              key={section.path}
              onClick={() => navigate(section.path)}
              className="w-full bg-white rounded-2xl border border-gray-100/50 p-4 text-left shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-300 group"
              style={{ animationDelay: `${idx * 60}ms` }}
              data-testid={`supp-card-${section.label.toLowerCase().replace(/\s+/g, '-')}`}
            >
              <div className="flex items-center gap-4">
                <div
                  className={`rounded-2xl bg-gradient-to-br ${section.gradient} flex items-center justify-center shadow-lg flex-shrink-0 group-hover:scale-105 transition-transform duration-300`}
                  style={{ width: '52px', height: '52px', boxShadow: `0 4px 14px ${section.color}30` }}
                >
                  <IconComp size={24} className="text-white" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-bold text-gray-900 text-sm" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
                    {section.label}
                  </p>
                  <p className="text-xs text-gray-400 mt-0.5">{section.description}</p>
                </div>
                <div className="text-gray-300 group-hover:text-gray-500 transition-colors">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m9 18 6-6-6-6"/></svg>
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ClientSupplementsPage;
